(function(app) {

    app.provider("permissionService",
    [
        function() {
            this.$get = [
                "_", function(_) {
                    return {
                        setPermissions: setPermissions,
                        getPermissions: getPermissions,
                        hasAllPermissions: hasAllPermissions,
                        removeStoredPermissions: removeStoredPermissions,
                        setOnBehalfOfUserId: setOnBehalfOfUserId,
                        getOnBehalfOfUserId: getOnBehalfOfUserId,
                        setUserDelegateId: setUserDelegateId,                   
                        removeStoredOnBehalfOfUserId: removeStoredOnBehalfOfUserId                     
                    };

                    function setPermissions(permissions) {                        
                        localStorage.setItem("Auth.Permissions", JSON.stringify(permissions));
                    }

                    function getPermissions() {
                        return JSON.parse(localStorage.getItem("Auth.Permissions"));
                    }

                    function hasAllPermissions(permissions) {
                        var current = getPermissions();
                        var hasAll = true;
                        for (var i = 0; i < permissions.length; i++) {
                            if (!_.find(current,
                                function(row) {
                                    return row.AccessObject === permissions[i].AccessObject &&
                                        row.ActionType === permissions[i].ActionType;
                                }))
                                hasAll = false;
                        }
                        return hasAll;
                    }

                    function removeStoredPermissions() {
                        localStorage.removeItem("Auth.Permissions");
                    }

                    function removeStoredOnBehalfOfUserId() {
                        localStorage.removeItem("Auth.OnBehalfOfUserId");
                    }
                  
                    function setOnBehalfOfUserId(userId) {
                        localStorage.setItem("Auth.OnBehalfOfUserId", userId);
                    }
                    function getOnBehalfOfUserId() {
                        return localStorage.getItem("Auth.OnBehalfOfUserId");
                    }

                    function setUserDelegateId(userDelegateId) {
                        localStorage.setItem("Auth.UserDelegateId", userDelegateId);
                    }                 
                }
            ];
        }
    ]);
})(window.app); // jshint ignore:line